import { Sidebar } from "@components/layout/Sidebar";
import { SidebarNavLink } from "@components/layout/SidebarNavLink";
import { NotFoundPage } from "@components/NotFoundPage";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { FlaskConicalIcon } from "lucide-react";

export const Route = createFileRoute("/library")({
  component: LibraryLayout,
  notFoundComponent: () => <NotFoundPage />,
});

function LibraryLayout() {
  return (
    <div className="flex flex-1 overflow-hidden">
      <Sidebar className="w-72 shrink-0">
        <div className="flex h-8 items-center">
          <span className="font-medium text-gray-600 text-sm">Library</span>
        </div>
        <nav className="mt-4 space-y-1">
          <SidebarNavLink to="/library/primers">
            <FlaskConicalIcon className="size-4" />
            Primers
          </SidebarNavLink>
        </nav>
      </Sidebar>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
